export default {
    header:{
        addWidget: {
            title: "Add widget",
            button: {
                title: "Add a widget",
                hide: "Hide added widgets"
            }
        },
        datePicker:{
            title: "Datum",
            options: {
                range: "Range",
                today: "Today",
                yesterday: "Yesterday",
                last7Days: "Last 7 days",
                thisWeek: "This week",
                last30Days: "Last 30 days",
                thisMonth: "This month",
                lastYear: "Last year",
                thisYear: "This year",
            },
            compareTo: {
                title: "Compare to",
                previousPeriod: "Previous period",
                previousYear: "Previous year"
            },
            cancel: "Cancel",
            apply: "Apply",
            wrongStartDate: "Start date can't be before %{date}."
        },
        warning: {
            tooltip: "Click for more information"
        },
        connection: {
            up: "connection UP",
            down: "connection DOWN"
        }
    },
    widget:{
        options:{
            move: "Move",
            delete: "Delete"
        },
        moreInfo: "More information",
        noData: "No data available for this widget.",
        noDataForPill: "No data available for %{pill}.",
        sync:{
            object: "Objects",
            problem: "Problem",
            nothing: "No object locks, great work!"
        },
        search:{
            terms:{
                title: "Search term",
                value: "# Searches"
            }
        },
        topProducts: {
            tableTitle: "Product"
        },
        topClients: {
            tableTitle: "Client",
        },
        filters: {
            logins: "Logins",
            sales: "Sales",
            orders: "Orders",
            views: "Views"
        },
        pageviews: {
            name: "Pageviews",
            info: "Shows the most visited pages with filters for URL, Account, and pageview count"
        },
        pageVisits: {
            name: "Last Visits",
            info: "Shows the most recent page visits with filters for URL and Account"
        }
    },
    footer:{
        cancel: "Cancel",
        save: "Save changes"
    }
}